// Pieces shared by the help pages: topic icons, article rows, the "still need help" card.
import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronRight,
  faCircleQuestion,
  faClapperboard,
  faComment,
  faCreditCard,
  faCrown,
  faEnvelope,
} from '@fortawesome/free-solid-svg-icons';

const TOPIC_ICONS = [
  [/frequently-asked/, faCircleQuestion],
  [/workspace/, faComment],
  [/youtube|studio/, faClapperboard],
  [/plans|minutes/, faCrown],
  [/billing/, faCreditCard],
];

export const topicIcon = slug => (TOPIC_ICONS.find(([re]) => re.test(slug)) || [null, faCircleQuestion])[1];

export const ArticleList = ({ articles }) => (
  <div className="help-list">
    {articles.map(article => (
      <Link key={article.slug} to={`/help/articles/${article.slug}`} className="help-list-row">
        <span className="help-list-text">
          <span className="help-list-title">{article.title}</span>
          {article.description && <span className="help-list-desc">{article.description}</span>}
        </span>
        <FontAwesomeIcon icon={faChevronRight} className="help-list-chevron" />
      </Link>
    ))}
  </div>
);

export const ContactCard = () => (
  <div className="help-contact">
    <div>
      <h2 className="help-contact-title">Still need help?</h2>
      <p className="help-contact-text">The Bumpups team usually replies within a day.</p>
    </div>
    <div className="help-contact-actions">
      <a href="mailto:contact@bumpups.com" className="help-btn help-btn--primary">
        <FontAwesomeIcon icon={faEnvelope} /> Email us
      </a>
    </div>
  </div>
);
